var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.screenEl
    ? _c("div", { staticClass: "fixedscreen-el" }, [
        _c("div", { staticClass: "main__blck" }, [
          _c(
            "div",
            {
              staticClass: "closed",
              on: {
                click: function($event) {
                  _vm.screenEl = !_vm.screenEl
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../../../img/icon/Close-black.svg"),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "relawaySM med p-black" }, [
            _vm._v("Try to win Xiaomi M365 pro")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "min-min" }, [
            _vm._v(
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
            )
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: require("../../../../img/Scooter.png"), alt: "" }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }